<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 11 11"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path fill="#FFF" fill-rule="nonzero" d="M7.885 2.42a1 1 0 1 1 1.63 1.16L5.947 8.59a1.5 1.5 0 0 1-2.39.07L1.92 6.627a1 1 0 0 1 1.558-1.254l1.222 1.52L7.885 2.42z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
